import { withInstall } from '../../../utils/with-install'
import ThreeLightSpot from './ThreeLightSpot.vue'

export const ElAmapThreeLightSpot = withInstall(ThreeLightSpot)
export default ElAmapThreeLightSpot
